import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "ccdda323-79d9-409c-ad48-6fba09474b2e",
  title: "Hansons Beginner Marathon",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "2 miles Easy",
      totalDistance: 2,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n12x400m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n5 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n8x600m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n5 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n5 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1km @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "15 miles Long Run",
      totalDistance: 15,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1,200m @ 5k-10k Pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ MP - 10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n8 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "16 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 11,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down ",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "16 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n2x3 miles @ MP - 10s w. 1 miles jog rest\n1.5 miles Cool Down ",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n9 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 11,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down ",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "16 miles Long Run",
      totalDistance: 16,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ MP - 10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 11,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ MP - 10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10.5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1 miles Warm Up\n10 miles Tempo @ Goal MP\n1 miles Cool Down",
      totalDistance: 12,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    { description: "Race Day!", totalDistance: 26.2 },
  ],
} as BuiltInPlan;
